import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=44ab7f5c&"
import script from "./Card.vue?vue&type=script&lang=js&"
export * from "./Card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AccordionControl: require('/usr/src/motec/components/AccordionControl.vue').default,AccordionPage: require('/usr/src/motec/components/AccordionPage.vue').default,PageColumnContent: require('/usr/src/motec/components/page/column/Content.vue').default})
